const ScrollableGrid = {
  padding:'0em 1em 1em 1em',
  maxHeight: '80vh',
  overflow:'auto'
}

export { ScrollableGrid }



// WEBPACK FOOTER //
// ./src/component/styles/ScrollableGrid.js